import React from 'react';
import { useTranslation } from 'react-i18next';
/**
 * @Description This function lets you return Logging.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function SysLog() {
    const { t } = useTranslation();
    const label = 'CONTENT.SETTINGS.GENERAL.';
    return (
        <div className="sgeneral-logging">
            <div className="sgeneral-syslog">
                <div>
                    <div>{t(label + 'IP')}</div>
                    <input placeholder={t(label + 'ENTER-IP')}/>
                </div>
                <div>
                    <div>{t(label + 'PORT')}</div>
                    <input className="sgeneral-syslog-port" type="number" defaultValue="514" min="0"/>
                </div>
            </div>
            <div>
                <div>{t(label + 'LOG-LEVEL')}</div>
                <div className="sgeneral-loglevel">
                    <div>{t(label + 'INFORMATION')}</div>
                    <div>{t(label + 'WARNING')}</div>
                    <div>{t(label + 'ERROR')}</div>
                </div>
            </div>
        </div>
    )
}

export default SysLog;
